var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'width': _vm.width + 'px', 'height': _vm.height + 'px'}),domProps:{"innerHTML":_vm._s(require(("!svg-inline-loader?idPrefix!./../../public/img/icons/" + _vm.icon + ".svg")))}})}
var staticRenderFns = []

export { render, staticRenderFns }